import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { NgbActiveModal, NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateUtil } from '@app/shared/util/DateUtil.model';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, AfterViewInit {

  @Input() startDate: NgbDate;
  @Input() endDate: NgbDate;
  @Input() defaultDate: NgbDate;
  @Input() min: NgbDate;
  @Input() max: NgbDate;
  @Input() range: boolean;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;

  constructor(
    private calendar: NgbCalendar,
    private activeModal: NgbActiveModal) {
  }

  ngAfterViewInit(): void {
  }

  onClickDateSelection(date: NgbDate): void {
    if (this.isValidate(date)) {
      if (this.range) {
        if (!this.fromDate && !this.toDate) {
          // es el primer valor front
          this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
          // es la selección del segundo valor to
          this.toDate = date;
          this.accept();
        } else {
          // rehacemos el primer valor front
          this.toDate = null;
          this.fromDate = date;
        }
      } else {
        this.fromDate = date;
        this.accept();
      }
    }
  }

  onDbClickDateSelection(date: NgbDate): void {
    if (this.isValidate(date)) {
      this.fromDate = date;
      this.accept();
    }
  }

  isHovered(date: NgbDate): boolean {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate): boolean {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate): boolean {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  isValidate(date: NgbDate): boolean {
    return (!this.min || date.equals(this.min) || date.after(this.min)) && (!this.max || date.equals(this.max) || date.before(this.max));
  }

  isBefore(date: NgbDate): boolean {
    if (!this.range) {
      return this.startDate && date.equals(this.startDate);
    } else {
      return (
        this.startDate && date.equals(this.startDate) ||
        (this.endDate && date.equals(this.endDate)) ||
        (this.startDate && this.endDate && date.after(this.startDate) && date.before(this.endDate)) ||
        (this.startDate && !this.endDate && date.after(this.startDate)) ||
        (this.endDate && !this.startDate && date.before(this.endDate)));
    }
  }

  ngOnInit(): void {
  }

  public accept(): void {
    let startDate: Date;
    let endDate: Date;
    if (this.fromDate) {
      startDate = DateUtil.getDateFromUTCDate(new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day));
    }
    if (this.toDate) {
      endDate = DateUtil.getDateFromUTCDate(new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day));
    }
    if (this.range) {
      this.activeModal.close({ start: startDate, end: endDate});
    } else {
      this.activeModal.close(startDate);
    }
  }

  public dismiss(): void {
    this.activeModal.dismiss();
  }
}
